import { GoogleCharts } from 'google-charts/dist/googleCharts';

class GeoChart {
  constructor() {
    this.settings = {
      chartSelector: '.geoChart',
    };
    this.geoOptions = {
      projection: { name: 'kavrayskiy-vii' },
      defaultColor: '#88b04b',
      datalessRegionColor: '#e1e1e1',
    };
  }

  init() {
    const charts = $(this.settings.chartSelector);
    const $this = this;
    if (charts.length) {
      charts.map((chart) => {
        GoogleCharts.load(() => $this.createChart(charts[chart]), 'geochart');
        return chart;
      });
    }
  }

  createChart(chart) {
    let data = chart.dataset.chartData ? chart.dataset.chartData.split(',') : [];
    data = data.map(element => [element]);
    data.unshift(['Country']);
    this.geoOptions.defaultColor = chart.dataset.color
      ? chart.dataset.color : this.geoOptions.defaultColor;
    const chartData = GoogleCharts.api.visualization.arrayToDataTable(data);
    const geomapChart = new GoogleCharts.api.visualization.GeoChart(chart);
    this.drawChart(geomapChart, chartData);
    const self = this;
    window.addEventListener('resize', () => {
      import('lodash/debounce').then((item) => {
        const debounce = item.default;
        debounce(self.drawChart(geomapChart, chartData), 100);
      })
    });
  }

  drawChart(geomapChart, chartData) {
    geomapChart.clearChart();
    geomapChart.draw(chartData, this.geoOptions);
  }
}

export default GeoChart;
